export default __webpack_public_path__ + "static/media/value-U.2076238d.svg";